import React from 'react';
import styles from './InternalAdminTool.module.scss';
import LogoHeader from './components/LogoHeader';
import SearchForm from './components/SearchForm';
import CustomerDetails from './components/CustomerDetails';
import { CustomerForInternalAdminTool } from '../types/CustomerForInternalAdminTool';
import { Spinner } from "@tag/tag-components-react-v4";

interface SearchViewProps {
  organisationId: string;
  accTickImage: string;
  accessLogoTickImage: string;
  onSearch: (clientId: string) => void;
  searchPerformed: boolean;
  foundCustomer: CustomerForInternalAdminTool | null;
  searchedClientId: string;
  loading?: boolean;
  accClient: string;
  setAccClient: (clientId: string) => void;
  corporateSite: string;
  setSelectedCustomer: (customer: CustomerForInternalAdminTool | null) => void;
}

const SearchView: React.FC<SearchViewProps> = ({
  organisationId,
  accTickImage,
  accessLogoTickImage,
  onSearch,
  searchPerformed,
  foundCustomer,
  searchedClientId,
  loading,
  accClient,
  setAccClient,
  corporateSite,
  setSelectedCustomer,
}) => {
  return (
    <div className={styles.container}>
      <LogoHeader
        accTickImage={accTickImage}
        accessLogoTickImage={accessLogoTickImage}
        organisationId={organisationId}
        corporateSite={corporateSite}
      />

        <SearchForm
            onSearch={onSearch}
            accClient={accClient}
            setAccClient={setAccClient}
        />
      
      {searchPerformed && (
        <div className={styles.resultsContainer}>
          {loading && <Spinner />}
          {!loading && foundCustomer && (
            <CustomerDetails
              foundCustomer={foundCustomer}
              setSelectedCustomer={setSelectedCustomer}
            />
          )}
          {!loading && !foundCustomer && (
            <div className={styles.noResults}>
              <p>No customer found with ID: <strong>{searchedClientId}</strong></p>
              <p>Please check the client ID and try again.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchView;
